module.exports = ".iframe-full-screen, .iframe-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  height: 100vh;\n  width: 100vw;\n  overflow: hidden;\n  z-index: 99999999; }\n\n.iframe-backdrop {\n  background-color: #45464c;\n  opacity: 0.5;\n  z-index: 99999998; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/common/iframe/iframe.component.scss
// module id = ./web/modern/components/common/iframe/iframe.component.scss
// module chunks = 0